import { Injectable, inject } from '@angular/core';
import { EDeliverableType } from '@enums/campaign.enum';
import { IDeliverableConfig } from '../deliverable-list.interface';
import { TextDeliverableService } from '../shared/text-deliverable/text-deliverable.service';
import { HashtagComponent } from './hashtag.component';

@Injectable({
  providedIn: 'root',
})
export class HashtagService {
  private readonly textDeliverableService = inject(TextDeliverableService);

  public getConfig(): IDeliverableConfig {
    return this.textDeliverableService.getConfig({
      component: HashtagComponent,
      defaultNameTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.hashTagDeliverable.title',
      deliverableType: EDeliverableType.hashTag,
    });
  }
}
